export default (props, vars) => !!vars?.loop?.item?.caption;
